__turbopack_context__.v({
  "youtube-player": "youtube-player-component-module-scss-module__PU4eRa__youtube-player",
  "youtube-player__iframe": "youtube-player-component-module-scss-module__PU4eRa__youtube-player__iframe",
  "youtube-player__play-button": "youtube-player-component-module-scss-module__PU4eRa__youtube-player__play-button",
  "youtube-player__preview": "youtube-player-component-module-scss-module__PU4eRa__youtube-player__preview",
  "youtube-player__preview-wrapper": "youtube-player-component-module-scss-module__PU4eRa__youtube-player__preview-wrapper",
  "youtube-player__video-frame": "youtube-player-component-module-scss-module__PU4eRa__youtube-player__video-frame",
});
